import { lazy } from 'react';

export const ForgotPage = lazy(() => import('./ForgotPage'));
